import { createSelector } from 'reselect';

import { PurposesState } from './slice';

/**
 * The selector for the `purposes` state store slice
 */
export const getPurposesSlice = (state: any): PurposesState => state.Purposes;

/**
 * The current list of purpose configured
 */
export const selectPurposeConfigurations = createSelector(
  getPurposesSlice,
  ({ configuration }) => configuration,
);

/**
 * The user's preferences
 */
export const selectPurposePreferences = createSelector(
  getPurposesSlice,
  ({ preferences = {} }) => preferences,
);

/**
 * The user identifiers for all partitions
 */
export const selectConsentIdentifiers = createSelector(
  getPurposesSlice,
  ({ identifiers = {} }) => identifiers,
);
